"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var index_1 = require("../index");
exports.InvoiceAPI = {
    getInvoices: function (companyId, filter) {
        var url = "/api/v1/company/" + companyId + "/invoices";
        return index_1.axios.get(url, {
            params: filter,
        }).then(function (response) { return response.data; });
    },
    getInvoiceById: function (companyId, invoiceId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/invoice/" + invoiceId).then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    checkCostPerUnit: function (companyId, productId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/invoice/checkCostPerUnit/" + productId).then(function (response) {
            var costPerUnit = response.data.data;
            return costPerUnit;
        });
    },
    createInvoice: function (companyId, createObject) {
        // Get createInvoice computed properties (total)
        var networkObject = mobx_1.toJS(createObject);
        networkObject.total = createObject.total;
        return index_1.axios.post("/api/v1/company/" + companyId + "/invoice", networkObject).then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    updateInvoice: function (companyId, invoiceId, updateObject) {
        // Get createInvoice computed properties (total)
        var networkObject = mobx_1.toJS(updateObject);
        networkObject.total = updateObject.total;
        return index_1.axios.put("/api/v1/company/" + companyId + "/invoice/" + invoiceId, networkObject).then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    progressInvoice: function (companyId, invoiceId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/invoice/" + invoiceId + "/inProgress").then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    completeInvoice: function (companyId, invoiceId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/invoice/" + invoiceId + "/complete").then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    cancelInvoice: function (companyId, invoiceId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/invoice/" + invoiceId + "/cancel").then(function (response) {
            var invoice = response.data;
            return invoice;
        });
    },
    exportInvoiceLots: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/invoice/lots").then(function (response) { return response.data; });
    },
    processReceipt: function (companyId, params) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.post("/api/v1/company/" + companyId + "/invoice/receipt", { params: params })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getCostHistory: function (companyId, filter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/invoice/costHistory", { params: filter })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
};
//# sourceMappingURL=InvoiceAPI.js.map